import AssetList from '@/views/asset/asset-list.vue';
import IncomeList from '@/views/asset/income-list.vue';
import ProfitsList from '@/views/asset/profits-list.vue';
import CashDetail from '@/views/asset/cash-detail.vue';
import CashList from '@/views/asset/cash-list.vue';

export default [
    {
        path: '/asset-list',
        component: AssetList,
        name: 'assetList'
    }, 
    {
        path: '/income-list',
        component: IncomeList,
        name: 'incomeList'
    },
    {
        path: '/profits-list',
        component: ProfitsList,
        name: 'profitsList'
    }, 
    {
        path: '/chsh-detail',
        component: CashDetail,
        name: 'cashDetail'
    }, 
    {
        path: '/chsh-list',
        component: CashList,
        name: 'cashList'
    }, 
]